import type { RouterConfig } from '@nuxt/schema'

// El scrollBehavior per defecte de Nuxt espera el hook `page:transition:finish`
// abans de moure el scroll. Amb el fade encadenat de les pàgines (leave 0.18s +
// enter amb 0.18s de retard, i el leave en `position: absolute`) el salt a dalt
// arriba massa tard i la vista nova s'obre a mitja pàgina. Aquí el forcem a
// cada canvi de ruta, animat perquè acompanyi la fosa en comptes de saltar.
const scrollMotion = (): ScrollBehavior => {
  if (import.meta.server) return 'auto'

  // Qui demana menys moviment al sistema es queda amb el salt sec
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ? 'instant'
    : 'smooth'
}

export default <RouterConfig>{
  scrollBehavior(to) {
    const behavior = scrollMotion()

    // Els enllaços amb àncora mantenen el seu destí; la resta, sempre a dalt
    if (to.hash && to.hash.length > 1) {
      return { el: to.hash, top: 0, behavior }
    }

    return { left: 0, top: 0, behavior }
  },
}
